import { render, staticRenderFns } from "./DemandResetPassword.vue?vue&type=template&id=5fe05e64&"
import script from "./DemandResetPassword.vue?vue&type=script&lang=js&"
export * from "./DemandResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports